import React from 'react';
import { Button, EmptyContent, Flex } from '@/components/ui';
import { IconFiles, IconUpload } from '@tabler/icons-react';

interface StudyFilesEmptyStateProps {
  onUploadClick: () => void;
}

export const StudyFilesEmptyState: React.FC<StudyFilesEmptyStateProps> = ({
  onUploadClick,
}) => {
  return (
    <EmptyContent
      style={{ alignSelf: 'center', minHeight: '400px' }}
      withIconBox
      icon={<IconFiles style={{ color: 'var(--green-9)' }} />}
      title="No study files uploaded yet"
      description="Start by uploading your first study file. You can drag & drop files anywhere on this page or use the upload button below."
      size="large"
    >
      <Flex direction="row" gap="3" align="center" justify="center">
        <Button
          startIcon={<IconUpload />}
          variant="classic"
          color="primary"
          type="button"
          onClick={onUploadClick}
        >
          Upload Files
        </Button>
      </Flex>
    </EmptyContent>
  );
};
